<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab class="mt-3" :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button 
                            v-if="tabIndex == 0" 
                            :loading="disabled" 
                            :disabled="$disabledCreateOrUpdate(this.company, $accessModule.companies)" 
                            label="Save" 
                            @click="save" />
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form>
                            <gofix-card classContent="mb-0 mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input label="Company Name" v-model="$v.company.name.$model" required></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="UEN" v-model="company.uen"></gofix-form-input>
                                    </b-col>
                                    <b-col md="4" v-if="companyType.value =='supplier' || companyType.value =='fm_companies'">
                                        <gofix-form-dropdown label="Tax Type" vLabel="tax_code" v-model="company.tax" :options="taxOptions" :filterable="false" @search="searchTaxCode">
                                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                {{option.tax_code}}
                                            </template>
                                            <template #gofixInput:dropdown:option="option">
                                                {{option.tax_code}}
                                            </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4" v-if="companyType.value =='client'">
                                        <!--<gofix-form-input label="Debtor Code" v-model="company.debtor_code"></gofix-form-input>-->
                                        
                                        <div class="property-dropdown dropdown-custom-tooltip">
                                            <gofix-form-dropdown
                                                label="Debtor Code"
                                                :filterable="false"
                                                :required="false"
                                                v-model="company.debtor_code"
                                                vLabel="source_code"
                                                :reduce="option => option.source_code"
                                                :options="debtorCodeOptions"
                                                @search="loadDebtorCode">
                                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                                            </template>
                                            <template #gofixInput:dropdown:option="option">
                                                <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                                            </template>
                                            </gofix-form-dropdown>
                                            
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row v-if="companyType.value =='supplier'">
                                    <!-- <b-col md="4">
                                        <gofix-form-input label="Creditor Code" v-model="company.creditor_code"></gofix-form-input>
                                        <div class="property-dropdown dropdown-custom-tooltip">
                                            <gofix-form-dropdown
                                                label="Creditor Code"
                                                :filterable="false"
                                                :clearable="true"
                                                :required="false"
                                                v-model="company.creditor_code"
                                                vLabel="source_code"
                                                :reduce="option => option.source_code"
                                                :options="creditorCodeOptions"
                                                @search="loadCreditorCode">
                                                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                    <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                                                </template>
                                                <template #gofixInput:dropdown:option="option">
                                                    <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                                                </template>
                                            </gofix-form-dropdown>
                                        </div>
                                    </b-col> -->
                                    <b-col md="4">
                                        <gofix-form-input label="External Vendor Code" v-model="company.vendor_code"></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Lift Company Code" v-model="company.lift_company_code"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row v-if="companyType.value =='fm_companies'">
                                    <b-col md="4">
                                        <gofix-form-input label="Bank GL Code" v-model="company.bank_code"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <!-- this.company.id &&  -->
                            <template v-if="companyType.value =='supplier'">
                                <CompanyCreditorCode :organization_id="Number($route.params.company_id)" :company="company" @updateCreditorCodes="updateCreditorCodes" @updateRemoveIds="updateRemoveIds" ref="CompanyCreditorCode"/>
                            </template>
                            <gofix-card classContent="mb-0" title="Mailing Address">
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-dropdown 
                                            class="gofixInputNoMinWidth" 
                                            label="Salutation" 
                                            vLabel="reference_value_text" 
                                            :reduce="option => option.reference_value_text" 
                                            v-model="company.mailing_address.salutation" 
                                            :options="salutationOptions" />
                                    </b-col>
                                    <b-col md="3">
                                        <gofix-form-input 
                                            label="First Name" 
                                            v-model="company.mailing_address.first_name" />
                                    </b-col>
                                    <b-col md="5">
                                        <gofix-form-input 
                                            label="Last Name" 
                                            v-model="company.mailing_address.last_name" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="3">
                                        <gofix-form-input-number 
                                            label="Phone" 
                                            v-model="company.mailing_address.primary_phone" 
                                            :integer-limit="15" 
                                            :include-thousands-separator="false" 
                                            :allowDecimal="false" />
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input 
                                            label="Email Address" 
                                            v-model="company.mailing_address.email" />
                                    </b-col>
                                    <b-col md="3">
                                        <div class="infoAddress">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <label class="m-0">Address</label>
                                                <gofix-button 
                                                    label="Edit" 
                                                    @click="$refs['modal-postal-address'].show()" 
                                                    noBorder fontNormal small />
                                            </div>
                                            <div class="info-right">{{company.mailing_address.display_address }}</div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card class="mb-0" classContent="mb-0" title="Billing Address">
                                <b-row>
                                    <b-col md="12" class="mb-20">
                                        <b-form-checkbox class="absoluteCheckbox bottom-0" v-model="checked">
                                            <span>Same as mailing address</span>
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-dropdown 
                                            class="gofixInputNoMinWidth" 
                                            label="Salutation" 
                                            vLabel="reference_value_text" 
                                            :reduce="option => option.reference_value_text" 
                                            v-model="company.billing_address.salutation" 
                                            :options="salutationOptions" 
                                            :disabled="checked" />
                                    </b-col>
                                    <b-col md="3">
                                        <gofix-form-input 
                                            label="First Name" 
                                            v-model="company.billing_address.first_name" 
                                            :disabled="checked" />
                                    </b-col>
                                    <b-col md="5">
                                        <gofix-form-input 
                                            label="Last Name" 
                                            v-model="company.billing_address.last_name" 
                                            :disabled="checked" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="3">
                                        <gofix-form-input-number 
                                            label="Phone" 
                                            v-model="company.billing_address.primary_phone" 
                                            :integer-limit="15" 
                                            :disabled="checked" 
                                            :include-thousands-separator="false" 
                                            :allowDecimal="false" />
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input 
                                            label="Email Address" 
                                            v-model="company.billing_address.email" 
                                            :disabled="checked" />
                                    </b-col>
                                    <b-col md="3">
                                        <div class="infoAddress">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <label class="m-0">Address</label>
                                                <gofix-button label="Edit" @click="$refs['modal-billing-address'].show()" noBorder fontNormal small></gofix-button>
                                            </div>
                                            <div class="info-right">{{company.billing_address.display_address }} </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                        </b-form>
                    </template>
                    <template slot="gofixTab:employees">
                        <Employees :company="company"></Employees>
                    </template>
                    <template slot="gofixTab:contactable-emails">
                        <ContactableEmails :company="company"></ContactableEmails>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Address" title="Address" hide-footer :centered="true" ref="modal-postal-address">
            <b-form class="pb-10">
                <gofix-form-input label="Street Number" v-model="company.mailing_address.street_no"></gofix-form-input>
                <gofix-form-input label="Street Name" v-model="company.mailing_address.street_name"></gofix-form-input>
                <gofix-form-input label="Unit no" v-model="company.mailing_address.unit_no"></gofix-form-input>
                <gofix-form-input label="Building Name" v-model="company.mailing_address.building_name"></gofix-form-input>
                <gofix-form-input label="Country" v-model="company.mailing_address.country" disabled></gofix-form-input>
                <gofix-form-input label="Postal code" v-model="company.mailing_address.postal_code"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="hanldeAddressPostal" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Address" title="Address" hide-footer :centered="true" ref="modal-billing-address">
            <b-form class="pb-10">
                <gofix-form-input label="Street Number" v-model="company.billing_address.street_no" :disabled="checked"></gofix-form-input>
                <gofix-form-input label="Street Name" v-model="company.billing_address.street_name" :disabled="checked"></gofix-form-input>
                <gofix-form-input label="Unit no" v-model="company.billing_address.unit_no" :disabled="checked"></gofix-form-input>
                <gofix-form-input label="Building Name" v-model="company.billing_address.building_name" :disabled="checked"></gofix-form-input>
                <gofix-form-input label="Country" v-model="company.billing_address.country" disabled></gofix-form-input>
                <gofix-form-input label="Postal code" v-model="company.billing_address.postal_code"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="hanldeAddressBilling" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators';
const Employees = () => import('./Employees')
import { generalAddressFormat } from "./../../_commonVar.js";
const CompanyCreditorCode = () => import("./CompanyCreditorCode")
const ContactableEmails = () => import("./ContactableEmails")
export default {
    name: 'company-info',
    components: { Employees, CompanyCreditorCode, ContactableEmails },
    data() {
        return {
            tabData: [{
                    key: "basic-info",
                    title: "Basic Info",
                    active: true
                },
                {
                    key: "employees",
                    title: "Employees",
                    active: false,
                    disabled: this.$route.params.company_id == 0,
                }
            ],
            tabIndex: 0,
            disabled: false,
            company: {
                id: '',
                name: '',
                is_fm_company: false,
                is_supplier: false,
                creditor_code: '',
                vendor_code: '',
                debtor_code: '',
                customer_code: '',
                bank_code: '',
                tax_id: '',
                uen: '',
                tax: null,
                mailing_address: {
                    salutation: '',
                    first_name: '',
                    last_name: '',
                    primary_phone: '',
                    email: '',
                    street_no: '',
                    street_name: '',
                    building_name: '',
                    unit_no: '',
                    country: 'Singapore',
                    postal_code: '',
                    display_address: ''
                },
                billing_address: {
                    salutation: '',
                    first_name: '',
                    last_name: '',
                    primary_phone: '',
                    email: '',
                    street_no: '',
                    street_name: '',
                    building_name: '',
                    unit_no: '',
                    country: 'Singapore',
                    postal_code: '',
                    display_address: ''
                },
                creditor_codes: [],
                lift_company_code: null
            },
            organizations: [],
            salutationOptions: [],
            taxOptions: [],
            checked: false,
            timer: null,
            debtorCodeOptions:[],
            creditorCodeOptions:[],
            removeIds: []
        }
    },
    mixins: [validationMixin],
    validations: {
        company: {
            name: {
                required
            },
        }
    },
    created() {
        if (!this.$route.params.hasOwnProperty('company_id') || (this.$route.params.company_id != 0 && isNaN(this.$route.params.company_id))) {
            return this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path);
        }

        if (this.$route.params.company_id != 0) {
            this.$store.dispatch('AllCompanyController/getOrganizations', this.$route.params.company_id)
                .then(response => {
                    if (response.data.data.code) {
                        return this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path);
                    }
                    this.setData(response.data.data)
                })
                .catch(error => {
                    return this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path);
                })
        }
        this.loadTax();
        this.getSalutations();
        if (this.$route.path.includes('supplier')) {
            this.companyType.value = 'supplier';
            this.company.is_supplier = true;
            this.company.is_fm_company = false;

            let arrFind = this.tabData.filter(item => item.key == 'contactable-emails');
            if(!arrFind.length) {
                this.tabData.push({
                    key: "contactable-emails",
                    title: "Contactable Emails",
                    active: false,
                    disabled: this.$route.params.company_id == 0,
                })
            }
        } else if (this.$route.path.includes('client')) {
            this.companyType.value = 'client';
            this.company.is_supplier = false;
            this.company.is_fm_company = false;
        } else {
            this.companyType.value = 'fm_companies';
            this.company.is_supplier = false;
            this.company.is_fm_company = true;
        }
        this.loadDebtorCode();
        this.loadCreditorCode();
    },
    watch: {
        checked: function(val) {
            if (val) {
                let data = Object.assign({}, this.company.billing_address);
                this.company.billing_address = Object.assign({}, this.company.mailing_address);
                this.company.billing_address.id = data.id;
            } else {
                this.company.billing_address = {
                    salutation: '',
                    first_name: '',
                    last_name: '',
                    primary_phone: '',
                    email: '',
                    street_no: '',
                    street_name: '',
                    building_name: '',
                    unit_no: '',
                    country: 'Singapore',
                    postal_code: '',
                    display_address: ''
                }
            }
        },
        "company.id": function(val) {
            if (val) {
                this.tabData[1].disabled = false;
            }
        }
    },
    computed: {
        ...mapGetters({
            companyType: 'AllCompanyController/companyType'
        })
    },
    methods: {
        loadTax(filter = {}, limit = 100) {
            let request = {
                isActive: 1,
                isNotSave: 1,
                limit: limit,
                filter: filter
            }
            this.$store.dispatch("TaxVersioningController/getTaxItems", request).then(data => {
                this.taxOptions = data.items;
            });
        },
        searchTaxCode(search, loading) {
            this.taxOptions = []
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                try {
                    this.loadTax({ tax_code: search }, 100);
                    loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        is_fm_company($event) {
            if (this.company.is_supplier) {
                event.stopPropagation()
                event.preventDefault()
                return this.$alertNotification("You have marked Is Supplier so you cannot mark Flatform Owner.", "warning");
            }
        },
        is_supplier($event) {
            if (this.company.is_fm_company) {
                event.stopPropagation()
                event.preventDefault()
                return this.$alertNotification("You have marked Flatform Owner so you cannot mark Is Supplier.", "warning");
            }
        },
        setData(data) {
            if (data && data.id && this.$route.params.company_id != 0) {

                if (!data.mailing_address) {
                    data.mailing_address = {
                        salutation: '',
                        first_name: '',
                        last_name: '',
                        primary_phone: '',
                        email: '',
                        street_no: '',
                        street_name: '',
                        building_name: '',
                        unit_no: '',
                        country: 'Singapore',
                        postal_code: '',
                        display_address: ''
                    }
                }

                if (!data.billing_address) {
                    data.billing_address = {
                        salutation: '',
                        first_name: '',
                        last_name: '',
                        primary_phone: '',
                        email: '',
                        street_no: '',
                        street_name: '',
                        building_name: '',
                        unit_no: '',
                        country: 'Singapore',
                        postal_code: '',
                        display_address: ''
                    }
                }

                this.company = data;
            }
        },
        save() {
            this.$v.$touch()

            if ( !this.company.name ) {
                return this.$alertNotification('Company Name is required', 'danger');
            }
            
            if (!this.$v.company.$invalid) {
                let item = Object.assign({}, this.company);
                item.tax_id = item.tax ? item.tax.id : null;
                if(this.removeIds.length) item.remove_creditor_ids = this.removeIds;
                let api = 'createItem'
                let keyMessage = 'adding'
                if (item.id) {
                    keyMessage = 'editing';
                    api = 'updateItem';
                    delete item.address;
                }
                this.disabled = true;
                this.$store.dispatch('AllCompanyController/' + api, item).then(async data => {
                        this.company.id = data.data.data.id;
                        if (!item.id) {
                            this.setData(data.data.data);
                            await this.$router.push(`${this.$route.matched[this.$route.matched.length - 1].parent.path}/${data.data.data.id}`)
                        }
                        this.disabled = false;
                        await this.$alertNotification(this.$notificationV2(keyMessage, 'company'));
                        this.$refs.CompanyCreditorCode.getItems();
                        this.$refs.CompanyCreditorCode.modalDel.removeIds = [];
                        this.$nextTick(() => {
                            this.$v.company.$reset()
                        })
                    })
                    .catch(error => {
                        this.disabled = false;
                        this.$alertNotification(error.response.data.error.message.error, "danger")
                    });
            }
        },
        hanldeAddressPostal() {
            this.company.mailing_address.display_address = generalAddressFormat(this.company.mailing_address)
            this.$refs['modal-postal-address'].hide()
        },
        hanldeAddressBilling() {
            this.company.billing_address.display_address = generalAddressFormat(this.company.billing_address)
            this.$refs['modal-billing-address'].hide()
        },
        getSalutations() {
            let filter = { reference_type: "Salutation" };
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.salutationOptions = response.items;
                })
        },
        loadDebtorCode(search = null){
            let filter = {
                source_type: "C",
                is_blocked: 0,
                source_code: search || null,
            };
            let params = {
              filter: filter,
              limit: 50,
              sortColumn: "source_code",
              sortDirection: "asc",
            };
            this.$store.dispatch(`ERPMasterCodeController/getItems`, params)
                .then(response => {
                  this.debtorCodeOptions = response.items;
                })
        },
        loadCreditorCode(search = null){
                let filter = {
                    source_type: "S",
                    is_blocked: 0,
                    source_code: search || null,
                };
                let params = {
                  filter: filter,
                  limit: 50,
                  sortColumn: "source_code",
                  sortDirection: "asc",
                };
                this.$store.dispatch(`ERPMasterCodeController/getItems`, params)
                    .then(response => {
                      this.creditorCodeOptions = response.items;
                    })
        },
        updateCreditorCodes(val) {
            this.company.creditor_codes = val
        },
        updateRemoveIds(val) {
            this.removeIds = val
        }
    }
}
</script>